import {z} from '@hono/zod-openapi';

import {amount} from './amount';
import {DeadStockBucketSchema} from './DeadStockBucketSchema';

export const DeadStockCardSchema = z
  .object({
    id: z.string(),
    catalogNumber: z.string().nullable(),
    name: z.string().nullable(),
    manufacturerId: z.string().nullable(),
    warehouseId: z.string(),
    warehouseName: z.string().nullable(),
    /**
     * `quantity` is non-nullable because the snapshot's `aged` CTE already filters
     * `quantity > 0`, which excludes NULL. The two value fields are nullable: an unpriced
     * movement makes them unknown. All three use `amount` rather than `z.coerce.number()`
     * so an unknown value fails loudly instead of reading as zero.
     */
    quantity: amount,
    inventoryValue: amount.nullable(),
    sellingPriceWithoutVat: amount.nullable(),
    lastIssueDate: z.string().date().nullable(),
    bucket: DeadStockBucketSchema,
  })
  .openapi('DeadStockCard');

export type DeadStockCard = z.infer<typeof DeadStockCardSchema>;
